module.exports = __webpack_public_path__ + "img/sign_250020784_1.39064083.png";